module.exports = __webpack_public_path__ + "img/Druid.67455df1.png";